// ✅ CatalogueOutils.jsx – Affichage public des outils agricoles avec filtres + lien détail
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import MenuNav from "../components/Menunav";
import MobileMenu from "../components/MobileMenu";
import FooterOutils from "../components/Footer";

export default function CatalogueOutils() {
    const [items, setItems] = useState([]);
    const [search, setSearch] = useState("");
    const [categorieFilter, setCategorieFilter] = useState("");
    const [marqueFilter, setMarqueFilter] = useState("");

    useEffect(() => {
        const fetchItems = async () => {
            const snapshot = await getDocs(collection(db, "items"));
            const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
            setItems(data.filter((item) => item.disponible));
        };
        fetchItems();
    }, []);

    const categories = [...new Set(items.map((i) => i.categorie).filter(Boolean))];
    const marques = [...new Set(items.map((i) => i.marque).filter(Boolean))];

    const filteredItems = items.filter((item) => {
        return (
            (!search || item.nom.toLowerCase().includes(search.toLowerCase())) &&
            (!categorieFilter || item.categorie === categorieFilter) &&
            (!marqueFilter || item.marque === marqueFilter)
        );
    });

    return (
        <>
            <MenuNav />
            <MobileMenu />

            <div className="container py-4">
                <h2 className="mb-4 fw-bold">Catalogue des Outils Agricoles</h2>

                {/* Filtres */}
                <div className="row g-3 mb-4">
                    <div className="col-md-4">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="🔍 Rechercher un outil"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                    <div className="col-md-4">
                        <select
                            className="form-select"
                            value={categorieFilter}
                            onChange={(e) => setCategorieFilter(e.target.value)}
                        >
                            <option value="">Toutes catégories</option>
                            {categories.map((cat, i) => (
                                <option key={i} value={cat}>{cat}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <select
                            className="form-select"
                            value={marqueFilter}
                            onChange={(e) => setMarqueFilter(e.target.value)}
                        >
                            <option value="">Toutes marques</option>
                            {marques.map((m, i) => (
                                <option key={i} value={m}>{m}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Résultats */}
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 g-4">
                    {filteredItems.map((item) => (
                        <div className="col" key={item.id}>
                            <Link to={`/outil/${item.slug}`} className="text-decoration-none text-dark">
                                <div className="card h-100 shadow rounded">
                                    {item.imageUrls?.[0] && (
                                        <img
                                            src={item.imageUrls[0]}
                                            alt={item.nom}
                                            className="card-img-top"
                                            style={{ height: "480px", objectFit: "cover" }}
                                        />
                                    )}
                                    <div className="card-body">
                                        <h5 className="card-title fw-bold mb-2">{item.nom}</h5>
                                        <p className="text-muted mb-1">{item.marque} - {item.modele}</p>
                                        <p className="fw-bold text-success fs-6 mb-0">
                                            {item.prix ? `Prix à la demande` : "Prix à la demande"}
                                        </p>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>


                {filteredItems.length === 0 && (
                    <div className="text-center mt-4 text-muted">Aucun outil trouvé.</div>
                )}
            </div>
            <FooterOutils />
        </>
    );
}
